import { useMutation } from 'convex/react';
import { api } from 'convex/_generated/api';
import { Id } from 'convex/_generated/dataModel';

export function useCreateGarden() {
  return useMutation(api.gardens.mutations.createGarden).withOptimisticUpdate(
    (localStore, args) => {
      const current = localStore.getQuery(api.gardens.queries.getUserGardens, {});
      if (current === undefined) return;

      const rows = args.rows ?? 8;
      const columns = args.columns ?? 10;
      const availableCells = Array.from({ length: rows }, (_, row) =>
        Array.from({ length: columns }, (_, col) => ({ row, col }))
      ).flat();

      localStore.setQuery(api.gardens.queries.getUserGardens, {}, [
        ...current,
        {
          _id: `__opt_${Date.now()}` as unknown as Id<'gardens'>,
          _creationTime: Date.now(),
          userId: '' as unknown as Id<'users'>,
          name: args.name,
          rows,
          columns,
          cellSettings: [],
          plants: [],
          availableCells,
        },
      ]);
    }
  );
}
